module.exports = __webpack_public_path__ + "img/foot_logo.d19a5585.png";